import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { MiscService } from '../../_service/misc.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import {MatDialog} from '@angular/material/dialog';
import {UpdateInsuranceModalComponent} from '../../insurance/update-insurance-modal/update-insurance-modal.component';
import {OpdModalComponent} from '../../opd/opd-modal/opd-modal.component';
import {IpdModalComponent} from '../../ipd/ipd-modal/ipd-modal.component';
import * as XLSX from 'xlsx';
import {formatDate} from '@angular/common';
import { FormBuilder, NgModel,FormGroup,Validators } from '@angular/forms';
import { UserService } from '../../_service/user.service';
declare var $: any;
import{ GlobalConstants } from '../../common/global-constants';
const apiUrlServ = GlobalConstants.openApiURL
@Component({
  selector: 'app-leads',
  templateUrl: './leads.component.html',
  styleUrls: ['./leads.component.css']
})
export class LeadsComponent implements OnInit {
    descriptionForm: FormGroup;feedbackDescriptionForm:FormGroup;
    perpage:number=25;leads:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;treatment='';userId:string;
    pageSizeOptions = [10,25,50,100];pageIndex:number=0;leadStatus=[];bds=[];loaded:boolean=false;circles=[];circle='';bridgeno;
    search:string;lead_source:string;lead_status:string;bd:string;start_date:string='';end_date:string='';treatments=[];leadStatus_copy=[];bds_copy=[];circles_copy=[];treatments_copy=[];treatCategory=[];treatCategory_copy=[];
    copyData:boolean= false;LeadId;category_filter:string;payment_mode:string;lead_category_filter='';
    submitted:boolean=false;showopdDonebutIpdNotDone:string;s3url:string='';tertiary_city_filter:string;gender:string;lead_sources=[]; lead_sources_copy=[];bridge_number_lists=[];bridge_number_lists_copy=[];
    tertiarycityFilter:boolean=false;isCMAccess:string;start_date_follow_up:string='';end_date_follow_up:string='';c2crecording:string; showNumberArray=[];
    displayInactiveUsersLead:boolean;submittedPartners:boolean=false;partner_leads=[];start_date_dump ='';
    end_date_dump = '';dump_loading:boolean=false;dump_from_paging:number;dump_to_paging:number;dump_per_page:number;dump_total:number=0;paging_html_dump:any='';date_range_dump:string='';export_dump_with_c2c:string;export_dump_with_kalera_call:string;updatedLeadsStatus:string;notUpdatedLeadsStatus:string;pre_sale_users_filter:string;allpre_sale_users = [];marketing_remarks:string;is_presales_access:string;is_doctor_access:string;
    mdSpokData=[];mdSpokData_copy=[];mdspok='';md_source:number=34; click_to_call_loading:boolean=false;response_call_id='';progression_msg='';end_to_call_btn_disable=false;feedbackDescLoading: boolean = false;
    @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
    @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
    @ViewChild('followupdateRangeStart', {static: false}) followupdateRangeStart: ElementRef;
    @ViewChild('followupdateRangeEnd', {static: false}) followupdateRangeEnd: ElementRef;
    @ViewChild('csvUpload', {static: false}) csvUpload: ElementRef;
    @ViewChild('csvUploadFb', {static: false}) csvUploadFb: ElementRef;
    @ViewChild('csvUpdateFollowUP', {static: false}) csvUpdateFollowUP: ElementRef;
    @ViewChild('csvUploadPartners', {static: false}) csvUploadPartners: ElementRef;
    @ViewChild('csvUploadLeadsStatusUpdate', {static: false}) csvUploadLeadsStatusUpdate: ElementRef;
    @ViewChild('csvUploadOtherLead', {static: false}) csvUploadOtherLead: ElementRef;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('dateRangeStartDump', {static: false}) dateRangeStartDump: ElementRef;
    @ViewChild('dateRangeEndDump', {static: false}) dateRangeEndDump: ElementRef;

    constructor(private formBuilder: FormBuilder,private leadapi:LeadsService,private sharedapi:SharedService,private dialog:MatDialog,public miscapi:MiscService,public router: Router,private userapi:UserService) { 
        this.descriptionForm = this.formBuilder.group({ 
            'lead_id' : [null, Validators.required],
            'mdspok_description' : [null, Validators.required],
        });
        this.feedbackDescriptionForm = this.formBuilder.group({ 
            'lead_id' : [null, Validators.required],
            'feedback_description' : [null, Validators.required],
        });
    }

    ngOnInit(): void
    {
        this.getbds();this.getcircle();this.getLeadSources();this.getBridgeNumberLists();
        this.getleadStatus();this.getTreatment();this.getTreatmentCategory();this.get_pre_salesbds();
        this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.userId = localStorage.getItem('loginuserId');
        this.s3url = localStorage.getItem('s3url');
        this.isCMAccess = localStorage.getItem('CMAccess');
        this.is_presales_access = localStorage.getItem('is_preSales');
        this.is_doctor_access = localStorage.getItem('is_doctor_access');
        //console.log(this.isCMAccess);
        if(this.userId=='5' || this.userId=='16' || this.userId=='45'){
            //console.log('if');
            this.router.navigateByUrl('dashboard');
        }

        if(this.myrole=='1' || (this.myrole=='15' && this.userId=='313')){
            this.pageSizeOptions = [10,25,50,100,500];
        }
        this.getMdSpok(this.md_source);
    }

    showhideNumber(showNumber,index){
        if(showNumber == '1'){
            this.showNumberArray[index] = true;
        }else{
            this.showNumberArray[index] = false;
        }
    }

    ngAfterViewInit() {
         this.loadleads(0,this.perpage);
    }

    resetFilters(){
        this.clearDate();
        this.clearDateFollowUp();
       
        this.search = ''; this.lead_source = '';  this.lead_status = ''; this.bd = ''; this.circle = ''; this.treatment = ''; this.bridgeno = ''; this.lead_category_filter = '';  this.category_filter = ''; this.payment_mode = ''; this.tertiary_city_filter = '';   this.displayInactiveUsersLead = false; this.c2crecording=''; this.showopdDonebutIpdNotDone = ''; this.gender = ''; this.pre_sale_users_filter = ''; this.marketing_remarks = '';this.mdspok='';
        this.loadleads(0,25);
    }

    getRefferalType(type){
        let status = 'NA';
        switch(type)
        {
            case 1:
            status = 'Doctor Refferal';
            break;
            case 2:
            status = 'Employee Refferal';
            break;
            case 3:
            status = 'Others Refferal';
            break;
            case 4:
            status = 'Patient Refferal';
            break;
            case 5:
            status = 'PX Refferal';
            break;
            case 6:
            status = 'Diagnostic';
            break;
            case 7:
            status = 'Lab';
            break;
            case 8:
            status = 'Phlebotomist';
            break;
            case 9:
            status = 'City Team';
            break;
            
        }
        return status;
    }

    setSearchValue(type){
        if(type =='lead_source'){
            $("#leadsourceSearch").val('');
            $("#leadsourceSearch").focus();
            this.lead_sources= this.lead_sources_copy;
        }else if(type=='lead_status'){
            $("#lead_status_Search").val('');
            $("#lead_status_Search").focus();
            this.leadStatus= this.leadStatus_copy;
        }else if(type=='bds'){
            $("#bd_search").val('');
            $("#bd_search").focus();
            this.bds= this.bds_copy;
        }else if(type=='circle'){
            $("#circleSearch").val('');
            $("#circleSearch").focus();
            this.circles= this.circles_copy;
        }else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        }else if(type=='leadCategory'){
            $("#leadcategorySearch").val('');
            $("#leadcategorySearch").focus();
            this.treatCategory= this.treatCategory_copy;
        }else if(type=='bridgeno'){
            $("#bridgenoSearch").val('');
            $("#bridgenoSearch").focus();
            this.bridge_number_lists= this.bridge_number_lists_copy;
        }else if(type=='mdspok'){
            $("#mdspokSearch").val('');
            $("#mdspokSearch").focus();
            this.mdSpokData= this.mdSpokData_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if (type == 'lead_source') {
            this.lead_sources = this.sharedapi.searchData(searchtText, this.lead_sources_copy, "source_name");
        }else if (type == 'lead_status') {
            this.leadStatus = this.sharedapi.searchData(searchtText, this.leadStatus_copy, "name");
        }else if(type == 'bds'){
            this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else  if (type == 'circle') {
            this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
        }else  if (type == 'treatment') {
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }else  if (type == 'leadCategory') {
        this.treatCategory = this.sharedapi.searchData(searchtText, this.treatCategory_copy, "name");
       }else if (type == 'bridgeno') {
        this.bridge_number_lists = this.sharedapi.searchData(searchtText, this.bridge_number_lists_copy, "bridge_number");
       }else if(type == 'mdspok'){
        this.mdSpokData = this.sharedapi.searchData(searchtText, this.mdSpokData_copy, "name");
    }
    }

    showDuplicateModal(leadid){
        this.LeadId= leadid;
        $('#duplicateModal').modal();
    }

    hideduplicateModal()
    {
        $('#duplicateModal').modal('hide');
    }


    copyLead(){
        this.copyData=true;
        this.leadapi.copyLeadData(this.LeadId).subscribe((data:any) => {
            if(data.status)
            {
                this.copyData=false;
                $('#duplicateModal').modal('hide');
                this.loadleads(0,this.perpage);
            }
        }, error => {
            this.copyData=false;
            this.sharedapi.checkError(error);
        });
    }


    async loadleads(pageIndex,perpage)
    {
        /* console.log(this.bd); */
        this.tertiarycityFilter = false;
        if(this.circle.indexOf('8') !== -1){
            this.tertiarycityFilter = true;
        }
        if(this.displayInactiveUsersLead == true) {
          this.getbds(0);
        } else {
          this.getbds();
        }
        this.leads = [];
        this.paginator.pageIndex = pageIndex;
        let qString = "";

        let lead_type = "";
        if(this.router.url == "/partner-leads"){
            lead_type = "partner";
        }

        if(this.router.url == "/gp-leads"){
            let lead_source_gp = '34';
            qString = 'search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+lead_source_gp+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&gender='+this.gender+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up+'&mdspok='+this.mdspok;
            
        }else if(this.router.url == "/px-leads"){
            let lead_source_px = '7';
            let referral_type = '5';
            qString = 'search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+lead_source_px+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&gender='+this.gender+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up+'&referral_type='+referral_type+'&mdspok='+this.mdspok;
            
        } else {
            qString = 'search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+this.lead_source+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&gender='+this.gender+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up+'&lead_type='+lead_type+'&pre_sale_users='+this.pre_sale_users_filter+'&marketing_remarks='+this.marketing_remarks+'&mdspok='+this.mdspok;
        }
        
        if(this.myrole=='14' && this.isCMAccess == '1'){
            this.loadPartnerleads(pageIndex,perpage);
        }


        this.loading = true;this.loaded = false;
        this.leadapi.getLeads(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
            this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.leads = data.data;
            }else{
                this.leads = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadleads(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadleads(event.pageIndex,event.pageSize);
    }

    async getleadStatus()
    {
        this.leadapi.getLeadStatus().subscribe((data:any) => {
            if(data.status)
            {
                this.leadStatus = data.data;
                this.leadStatus_copy = this.leadStatus;
            }else{
                this.leadStatus = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    get_pre_salesbds(){
        this.userapi.getpresalesbds().subscribe((data:any) => {
            if(data.status)
            {
                this.allpre_sale_users = data.data;
                
            }else{
                this.allpre_sale_users = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getbds(status=1)
    {
        this.leadapi.getbds(status).subscribe((data:any) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy = this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getcircle()
    {
        this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
                this.circles_copy = this.circles;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getLeadSources()
    {
        this.leadapi.getLeadSources().subscribe((data:any) => {
            if(data.status)
            {
                this.lead_sources = data.data;
                this.lead_sources_copy = this.lead_sources;
            }else{
                this.lead_sources = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    async getBridgeNumberLists()
    {
        this.leadapi.getBridgeNumberLists().subscribe((data:any) => {
            if(data.status)
            {
                this.bridge_number_lists = data.data;
                this.bridge_number_lists_copy = this.bridge_number_lists;
            }else{
                this.bridge_number_lists = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment()
    {
        this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy = this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
                this.treatCategory_copy = this.treatCategory;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    dateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.start_date = date1.value;
            this.end_date = date2.value;
            //this.loadleads(0,this.perpage);
        }
    }

    clearDate()
    {
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
        //this.loadleads(0,this.perpage);
    }

    dateRangeChangefollowUp(date1,date2)
    {
        if(date2.value)
        {
            this.start_date_follow_up = date1.value;
            this.end_date_follow_up = date2.value;
            //this.loadleads(0,this.perpage);
        }
    }

    clearDateFollowUp()
    {
        this.followupdateRangeStart.nativeElement.value = "";
        this.followupdateRangeEnd.nativeElement.value = "";
        this.start_date_follow_up = '';
        this.end_date_follow_up = '';
        //this.loadleads(0,this.perpage);
    }

    toJson(json)
    {
        return JSON.parse(json);
    }


    hideModal()
    {
        $('#myModal').modal('hide');
    }

    showModal()
    {
        $('#myModal').modal();
    }

    hideLeadStatusUpdateModal()
    {
        $('#myModalLeadStatusUpdate').modal('hide');
    }

    showLeadStatusUpdateModal()
    {
        $('#myModalLeadStatusUpdate').modal();
    }

    hideDataLeadStatusUpdateModal()
    {
        $('#myModalLeadDataStatusUpdate').modal('hide');
    }

    showDataLeadStatusUpdateModal()
    {
        $('#myModalLeadDataStatusUpdate').modal();
    }

    hideModalFb()
    {
        $('#myModalfb').modal('hide');
    }

    showModalFb()
    {
        $('#myModalfb').modal();
    }

    hideModalPartner()
    {
        $('#myModalpartners').modal('hide');
    }

    showModalPartners()
    {
        $('#myModalpartners').modal();
    }

    hideStatusModal()
    {
        $('#paymentTreatmentModal').modal('hide');
    }


    hidefollowupModal()
    {
        $('#followupModal').modal('hide');
    }

    showfollowupModal()
    {
        $('#followupModal').modal();
    }

    hideOtherLeads()
    {
        $('#myModalotherLeads').modal('hide');
    }

    showOtherLeads()
    {
        $('#myModalotherLeads').modal();
    }

    hideMdSpockDescriptionUpdateModal()
    {
        $('#myModalMdspockDescription').modal('hide');
    }

    showMdSpockDescriptionUpdateModal(leadId,description)
    {
        if(this.myrole=='1' || (this.myrole=='4' && this.is_doctor_access=='1')){
            this.descriptionForm.patchValue({
                'lead_id':leadId,  
                'mdspok_description':description
            })
            $('#myModalMdspockDescription').modal();
        }    
    }

    

    async selectFileOtherLeads(event)
    {
        this.submitted = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.leadapi.uploadcsvOtherLeads(formData)
        .subscribe((data:any) => {
            this.submitted = false;
            this.csvUploadFb.nativeElement.value = "";
            if(data.status)
            {
                this.hideOtherLeads();
                this.sharedapi.presentToast(data.msg);
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }

    async selectFileFb(event)
    {
        this.submitted = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.leadapi.uploadcsvFb(formData)
        .subscribe((data:any) => {
            this.submitted = false;
            this.csvUploadFb.nativeElement.value = "";
            if(data.status)
            {
                this.hideModalFb();
                this.sharedapi.presentToast(data.msg);
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }

    async selectFilePartners(event)
    {
        this.submittedPartners = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.leadapi.uploadcsvPartners(formData)
        .subscribe((data:any) => {
            this.submittedPartners = false;
            this.csvUploadPartners.nativeElement.value = "";
            if(data.status)
            {
                this.hideModalFb();
                this.sharedapi.presentToast(data.msg);
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }


    async selectFile(event)
    {
        this.submitted = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.leadapi.uploadcsv(formData)
        .subscribe((data:any) => {
            this.submitted = false;
            this.csvUpload.nativeElement.value = "";
            if(data.status)
            {
                this.hideModal();
                this.sharedapi.presentToast(data.msg);
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }

    async selectFileUpdateLeadStatus(event)
    {
        this.submitted = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.leadapi.uploadcsvLeadStatusUpdate(formData)
        .subscribe((data:any) => {
            this.submitted = false;
            this.csvUploadLeadsStatusUpdate.nativeElement.value = "";
            if(data.status)
            {
                this.hideLeadStatusUpdateModal();
                this.updatedLeadsStatus = data.updatedLeadId;
                this.notUpdatedLeadsStatus = data.notUpdatedLeadId;
                this.showDataLeadStatusUpdateModal();
                // this.sharedapi.presentToast(data.msg);
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }

    openInsuranceDialog(lead_id)
    {
        const dialogRef = this.dialog.open(UpdateInsuranceModalComponent, {
            width: '100%',height: '90%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    openOpdDialog(lead_id)
    {
        const dialogRef = this.dialog.open(OpdModalComponent, {
            width: '100%',height: '90%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    openIpdDialog(lead_id)
    {
        const dialogRef = this.dialog.open(IpdModalComponent, {
            width: '100%',height: '90%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    getSource(Srcstatus)
    {
        let status = 'NA';
        switch(Srcstatus)
        {
            case 1:
            status = 'Forms';
            break;
            case 2:
            status = 'Kaleyra';
            break;
            case 3:
            status = 'Practo';
            break;
            case 4:
            status = 'Consult Now';
            break;
            case 5:
            status = 'FB/IG';
            break;
            case 6:
            status = 'Youtube';
            break;
            case 7:
            status = 'Referral';
            break;
            case 8:
            status = 'Blogs';
            break;


        }
        return status;
    }

    getPaymentTreatmentStatus(leadId,actionType){
        this.leadapi.getpaymenttreatmentStatus(leadId).subscribe((data:any) => {
            if(data.status)
            {
                console.log(data);
                if(actionType=='Upload Insurance Card'){
                    if(data.result.status==true){
                        this.openInsuranceDialog(leadId);
                    }else{
                        $("#paymentTreatmentModal").modal();
                        $("#StatusText").text(data.result.message);
                    }
                }
                else if(actionType=='Post OPD'){
                    if(data.result.status==true){
                        this.openOpdDialog(leadId);
                    }else{
                        $("#paymentTreatmentModal").modal();
                        $("#StatusText").text(data.result.message);
                    }
                }

                else if(actionType=='Post IPD'){
                    if(data.result.status==true){
                        this.openIpdDialog(leadId);
                    }else{
                        $("#paymentTreatmentModal").modal();
                        $("#StatusText").text(data.result.message);
                    }
                }

                else if(actionType=='Create Duplicate Lead'){
                    if(data.result.status==true){
                        this.showDuplicateModal(leadId);
                    }else{
                        $("#paymentTreatmentModal").modal();
                        $("#StatusText").text(data.result.message);
                    }
                }

            }
        })
    }

    exportLeadData()
    {
        if(this.leads.length>0)
        {
            let data = [];
            let titles = ['Lead ID','Patient Id','Glamyo Patient Id','Lead Source','Bridge Number','Lead Status','Lead Location','Circle','Lead Owner','Employee Id','Treatment','Lead Catergory','Description','Lead Date','Surgery Date','Follow-up Date','Payment Mode','Policy Number','Form Lead Source','Recording Links','MD SPOC','MD SPOC Description','Form Ad Type','Form GCLID','Form Keywords','Campaign Name','Site','Ad Group Id','Match Type'];

            if(this.myrole=="1")
            {
                titles.push('Lead Name');
                titles.push('Lead Mobile');
            }
            if(this.myrole=="3" || this.myrole=='4')
            {
                titles.push('Lead Name');
            }
            if(this.myrole=="1" || this.myrole=='6')
            {
                titles.push('Marketing Remarks');
            }

            data.push(titles);
            for(let key in this.leads)
            {
                var surgery_date =''; var follow_update = "";
                if(this.leads[key].ipd_surgery_date){
                    surgery_date = formatDate(this.leads[key].ipd_surgery_date*1000, 'dd MMM, yyyy', 'en-US');
                }

                if(this.leads[key].followup_date){
                    follow_update = formatDate(this.leads[key].followup_date*1000, 'dd MMM, yyyy', 'en-US');
                }
                
                let exdata = [this.leads[key].id,this.leads[key].patient_id,this.leads[key].glamyo_patient_id,this.leads[key].source_name,this.leads[key].bridge_no,this.leads[key].lead_status_name,this.leads[key].city_name,this.leads[key].circle_name,this.leads[key].bd_name,this.leads[key].employee_id,this.leads[key].treatment_name,this.leads[key].catergoryName,this.leads[key].description,formatDate(this.leads[key].lead_time*1000, 'dd MMM, yyyy', 'en-US'),surgery_date,follow_update,this.sharedapi.getPaymentType(this.leads[key].payment_mode),this.leads[key].policy_number,this.leads[key].zoho_lead_source,this.leads[key].call_details,this.leads[key].spocperson,this.leads[key].md_spok_description,this.leads[key].zoho_ad_type,this.leads[key].gclid,this.leads[key].keywords,this.leads[key].campaign_name,this.leads[key].utm_site,this.leads[key].utm_agid,this.leads[key].matchtype];

                if(this.myrole=="1")
                {
                    exdata.push(this.leads[key].lead_name);
                    exdata.push(this.leads[key].mobile);
                }
                if(this.myrole=="3" || this.myrole=='4')
                {
                    exdata.push(this.leads[key].lead_name);
                }
                if(this.myrole=="1" || this.myrole=='6')
                {
                    exdata.push(this.leads[key].marketing_remarks);
                }


                data.push(exdata);
            }


            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'lead_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

    exportLeadDataforMatketing()
    {
        console.log(this.leads);
        if(this.leads.length>0)
        {
            let data = [];
            let titles = ['Lead ID','Lead Date','Lead Status','Treatment','Catergory','Source','Description','GCLID','Marketing Remarks'];

            data.push(titles);
            for(let key in this.leads)
            {
                if(this.leads[key].lead_status_id=='3' || this.leads[key].lead_status_id=='4' || this.leads[key].lead_status_id=='10' || this.leads[key].lead_status_id=='11' || this.leads[key].lead_status_id=='54' || this.leads[key].lead_status_id=='55' || this.leads[key].lead_status_id=='56' || this.leads[key].lead_status_id=='57' || this.leads[key].lead_status_id=='58' || this.leads[key].lead_status_id=='59'){
                    
                    let exdata = [this.leads[key].id,formatDate(this.leads[key].lead_time*1000, 'dd MMM, yyyy', 'en-US'),this.leads[key].lead_status_name,this.leads[key].treatment_name,this.leads[key].catergoryName,this.leads[key].source_name,this.leads[key].description,this.leads[key].gclid,this.leads[key].marketing_remarks
                ];
                 data.push(exdata);
                }
                
            }


            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'lead_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

    async loadPartnerleads(pageIndex,perpage)
    {
        /* console.log(this.bd); */
        this.tertiarycityFilter = false;
        if(this.circle.indexOf('8') !== -1){
            this.tertiarycityFilter = true;
        }
        if(this.displayInactiveUsersLead == true) {
          this.getbds(0);
        } else {
          this.getbds();
        }
        this.partner_leads = [];
        this.paginator.pageIndex = pageIndex;

        let lead_type = "";
        if(this.router.url == "/partner-leads"){
            lead_type = "partner";
        }

        let qString = "";
        if(this.router.url == "/gp-leads"){
            let lead_source_gp = '34';
            qString = 'search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+lead_source_gp+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&gender='+this.gender+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up;;
        }else if(this.router.url == "/px-leads"){
            let lead_source_px = '7';
            let referral_type = '5';
            qString = 'search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+lead_source_px+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&gender='+this.gender+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up+'&referral_type='+referral_type;;
        } else {
            qString = 'search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&lead_status='+this.lead_status+'&bd='+this.bd+'&lead_source='+this.lead_source+'&date_range='+this.start_date+'-'+this.end_date+'&ipdopnd='+this.showopdDonebutIpdNotDone+'&bridgeno='+this.bridgeno+'&category_filter='+this.category_filter+'&payment_mode='+this.payment_mode+'&lead_category_filter='+this.lead_category_filter+'&tertiary_city_filter='+this.tertiary_city_filter+'&display_inactive_user_list='+this.displayInactiveUsersLead+'&gender='+this.gender+'&follow_up_date_range='+this.start_date_follow_up+'-'+this.end_date_follow_up+'&lead_type='+lead_type;
            ;
        }
        


        this.loading = true;this.loaded = false;
        this.leadapi.getPartnerLeads(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
            this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.partner_leads = data.data;
            }else{
                this.partner_leads = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    exportLeadPartnerData()
    {
        if(this.partner_leads.length>0)
        {
            let data = [];
            
            let titles = [
                'Date',
                'Partner Name',
                'Patient Name',
                'Patient Age',
                'Location',
                'Agent Name',
                'Lead Source',
                'Lead Status',
                'Treatment Name',
                'Treatment Catergory',
                'Remarks',
                'Next Action Date',
                'Payment Mode',
                'OPD Status',
                'OPD Date',
                'Surgery Date',
                'Pre Auth Status',
                'Patient Discharge Date & Time',
                'Final Value',
            ];
            data.push(titles);
            for(let key in this.partner_leads)
            {
                var surgery_date =''; var follow_update = "";
                if(this.partner_leads[key].ipd_surgery_date){
                    surgery_date = formatDate(this.partner_leads[key].ipd_surgery_date*1000, 'dd MMM, yyyy', 'en-US');
                }

                if(this.partner_leads[key].followup_date){
                    follow_update = formatDate(this.partner_leads[key].followup_date*1000, 'dd MMM, yyyy', 'en-US');
                }
                var opd_status_name = '';
                if(this.partner_leads[key].opd_status == 0){
                    opd_status_name = 'Active';
                } else if(this.partner_leads[key].opd_status == 1){
                    opd_status_name = 'Completed';
                } else if(this.partner_leads[key].opd_status == 3){
                    opd_status_name = 'Cancelled';
                }

                var pre_auth_status = '';
                if(this.partner_leads[key].payment_mode == "Cashless")
                {
                    if(this.partner_leads[key].insurance_details_status > 0 && this.partner_leads[key].insurance_details_status <= 3){
                        pre_auth_status = 'Pre Auth Pending';
                    } else if(this.partner_leads[key].insurance_details_status > 0 && this.partner_leads[key].insurance_details_status > 3){
                        pre_auth_status = 'Pre Auth Approved';
                    }
                }
                

                var opd_appointment_time = '';
                if(this.partner_leads[key].opd_appointment_time)
                {
                    opd_appointment_time = formatDate(this.partner_leads[key].opd_appointment_time*1000, 'dd MMM, yyyy', 'en-US');
                }

                var discharge_date = '';
                if(this.partner_leads[key].discharge_date)
                {
                    discharge_date = formatDate(this.partner_leads[key].discharge_date*1000, 'dd MMM, yyyy', 'en-US');
                }
                var discharge_time = '';
                if(this.partner_leads[key].discharge_time)
                {
                    discharge_time = formatDate(this.partner_leads[key].discharge_time*1000, 'hh:mm aa', 'en-US');
                }
                
                let exdata = [
                    formatDate(this.partner_leads[key].lead_time*1000, 'dd MMM, yyyy', 'en-US'),
                    this.partner_leads[key].source_name,
                    this.partner_leads[key].lead_name,
                    this.partner_leads[key].patient_age,
                    this.partner_leads[key].city_name,
                    this.partner_leads[key].bd_name,
                    this.partner_leads[key].source_name,
                    this.partner_leads[key].lead_status_name,
                    this.partner_leads[key].treatment_name,
                    this.partner_leads[key].catergoryName,
                    this.partner_leads[key].description,
                    follow_update,
                    this.partner_leads[key].payment_mode,
                    opd_status_name,
                    opd_appointment_time,
                    surgery_date,
                    pre_auth_status,
                    discharge_date+' '+discharge_time,
                    this.partner_leads[key].final_bill_value
                ];
                data.push(exdata);
            }


            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'partner_lead_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

    exportPartnerLeadData()
    {   
        if(this.leads.length>0)
        {
            let data = [];
            let titles = ['Lead ID','Patient Id','Glamyo Patient Id','Lead Name','Lead Status','Lead Location','Circle','Lead Owner','Treatment','Lead Catergory','Description','Lead Date','Surgery Date','Follow-up Date','Payment Mode','MD SPOC','MD SPOC Description'];

            data.push(titles);
            for(let key in this.leads)
            {
                if(this.leads[key].lead_source=='32'){
                    var surgery_date =''; var follow_update = "";
                    if(this.leads[key].ipd_surgery_date){
                        surgery_date = formatDate(this.leads[key].ipd_surgery_date*1000, 'dd MMM, yyyy', 'en-US');
                    }
    
                    if(this.leads[key].followup_date){
                        follow_update = formatDate(this.leads[key].followup_date*1000, 'dd MMM, yyyy', 'en-US');
                    }
                    
                    let exdata = [this.leads[key].id,this.leads[key].patient_id,this.leads[key].glamyo_patient_id,this.leads[key].lead_name,this.leads[key].lead_status_name,this.leads[key].city_name,this.leads[key].circle_name,this.leads[key].bd_name,this.leads[key].treatment_name,this.leads[key].catergoryName,this.leads[key].description,formatDate(this.leads[key].lead_time*1000, 'dd MMM, yyyy', 'en-US'),surgery_date,follow_update,this.sharedapi.getPaymentType(this.leads[key].payment_mode),this.leads[key].spocperson,this.leads[key].md_spok_description];
    
                    data.push(exdata);
                }

            }
           
           let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'lead_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

    get f() { return this.descriptionForm.controls; }
    get f1() { return this.feedbackDescriptionForm.controls; }

    exportTrainingLeadData()
    {
        if(this.leads.length>0)
        {
            let data = [];
            let titles = [
                'Patient Id','Glamyo Patient Id', 'Lead Name','Lead Source', 'Lead Status', 'Lead Location', 'Circle', 'Lead Owner','Employee Id', 'Treatment', 'Description', 'Lead Time', 'First Action Taken Time' , 'First Action Taken' ,'Surgery Time','Follow-up Date', 'Kaleyra Recording Links'
            ];


            data.push(titles);
            for(let key in this.leads)
            {
                let kaleyra_recording_arr = [];
                if(this.leads[key].call_details){
                    kaleyra_recording_arr = JSON.parse(this.leads[key].call_details)
                }

                let kal_recording_url = '';
                if(kaleyra_recording_arr)
                {
                    for(let callD in kaleyra_recording_arr)
                    {
                        if(kaleyra_recording_arr[callD].call_recording_url)
                        {
                            kal_recording_url += kaleyra_recording_arr[callD].call_recording_url+'\n';
                        }
                    }
                }

                let first_leadAction = this.leads[key].first_leadAction;
                var firstActionTime = '';
                var firstActionText = '';
                if(first_leadAction){
                    let splitActionData = first_leadAction.split('@at@');
                    //console.log(splitActionData);
                    firstActionText = splitActionData[0];
                     firstActionTime = splitActionData[1];
                }
                
                

                var surgery_date =''; var follow_update = ""; var lead_time = "";
                if(this.leads[key].ipd_surgery_date){
                    surgery_date = formatDate(this.leads[key].ipd_surgery_date*1000, 'dd MMM, yyyy', 'en-US');
                }
                if(this.leads[key].followup_date){
                    follow_update = formatDate(this.leads[key].followup_date*1000, 'dd MMM, yyyy', 'en-US');
                }
                

                let LeadTime = formatDate(this.leads[key].lead_time*1000, 'dd/MM/YYYY', 'en-US');
                
                let exdata = [
                    this.leads[key].patient_id,
                    this.leads[key].glamyo_patient_id,
                    this.leads[key].lead_name,
                    
                    this.leads[key].source_name,
                    this.leads[key].lead_status_name,
                    this.leads[key].city_name,
                    this.leads[key].circle_name,
                    this.leads[key].bd_name,
                    this.leads[key].employee_id,
                    this.leads[key].treatment_name,
                    this.leads[key].description,
                    LeadTime,
                    firstActionTime,
                    firstActionText.replace(/<[^>]*>/g, ''),
                    surgery_date,
                    follow_update,
                    kal_recording_url
                ];
                data.push(exdata);
            }


            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'lead_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

    showModalLeadDump()
    {
        $('#leadDumpData').modal('show');
    }
    hideModalLeadDump()
    {
        window.location.reload();
    }

    dateRangeChangeDump(date1,date2)
    {
        if(date2.value)
        {
            this.start_date_dump = date1.value;
            this.end_date_dump = date2.value;
        }
    }

    clearDateDump()
    {
        this.dateRangeStartDump.nativeElement.value = "";
        this.dateRangeEndDump.nativeElement.value = "";
        this.start_date_dump = '';
        this.end_date_dump = '';
    }

    async getleaddumpByDate()
    {
        let qString = 'date_range='+this.start_date_dump+'-'+this.end_date_dump+'&withcc='+this.export_dump_with_c2c+'&kcall='+this.export_dump_with_kalera_call;
        this.dump_loading = true;
        this.paging_html_dump = "";
        this.leadapi.getleaddumpByDate(qString).subscribe((data:any) => {
            this.dump_loading = false;
            if(data.status){
                /* console.log(data.data); */
                this.dump_from_paging=data.data.from;
                if(this.dump_from_paging){
                    this.dump_to_paging=data.data.last_page;
                    this.dump_per_page=data.data.per_page;
                    this.dump_total=data.data.total;
                    this.date_range_dump=data.data.date_range;
                    this.paging_html_dump += '<div class="tableFixHead" style="overflow: scroll">  <table class="table table-striped"><thead><tr class="text-center"><th>#</th><th>Page Number</th><th>Action</th></tr></thead><tbody>';
                    for(let x:number=this.dump_from_paging; x<=this.dump_to_paging; ++x)
                    {
                        let from_text = 1;
                        if(x>1){
                            from_text = Number(((x-1)*this.dump_per_page)+1);
                        }
                        let to_text = Number(this.dump_per_page*x);
                        if(this.dump_to_paging == x){
                            to_text = ((Number(((x-1)*this.dump_per_page)+1) - 1) +(this.dump_per_page - Number(Number(this.dump_per_page*x) - this.dump_total)));
                        }
                        this.paging_html_dump += "<tr class='text-center'><td>"+x+"</td><td>Page "+x+" (From "+from_text+" to "+to_text+")</td><td><a href='"+apiUrlServ+"get-leads-dump-by-date?page="+x+"&"+qString+"' target='_blank'>Download CSV</td></tr>";
                    }
                    this.paging_html_dump += "</tbody><table></div>";
                } else {
                    this.sharedapi.presentToast("No data Found.");
                }
            } else {
                this.sharedapi.presentToast(data.msg);
                this.dump_from_paging=0;
                this.dump_to_paging=0;
                this.dump_per_page=0;
                this.dump_total=0;
                this.paging_html_dump = "";
                this.date_range_dump="";
            }
        }, error => {
            this.dump_loading = false;
            this.sharedapi.checkError(error);
        });
    }


    async selectFileFollowUp(event)
    {
        this.submitted = true;
        let file = event.target.files.item(0);
        const formData = new FormData();
        formData.append('file', file);
        this.leadapi.uploadcsvLeadFollowupUpdate(formData)
        .subscribe((data:any) => {
            this.submitted = false;
            this.csvUpdateFollowUP.nativeElement.value = "";
            if(data.status)
            {
                this.hideModalFb();
                this.sharedapi.presentToast(data.msg);
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error =>
            {
                this.sharedapi.checkError(error);
            });
    }

    async getMdSpok(md_source) {
        await this.leadapi.getMdSpokUsers(this.md_source).subscribe((response: any) => {
            console.log(response);
          if (response.status) {
            this.mdSpokData = response.data;
            this.mdSpokData_copy = this.mdSpokData;
          } else {
            this.mdSpokData = [];
          }
        }, error => {
          this.sharedapi.checkError(error);
        });
    
      }

      async saveMdspockDescription(){
    	this.submitted = true;
        this.loading = true;
        if (this.descriptionForm.invalid) {
            this.loading = false;
            return;
        }
        await this.leadapi.saveMdspockDescription(this.descriptionForm.value)
         .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status){
                this.sharedapi.presentToast(data.msg); 
                this.loadleads(0,25); 
                this.hideMdSpockDescriptionUpdateModal();
            }
            else{
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.sharedapi.checkError(error);
            }); 
    }

    click_to_call_function(lead_id)
    {
        this.click_to_call_loading = true;
        let lead_id_arr = {'lead_id': lead_id};
        this.leadapi.clickTOCall(lead_id_arr).subscribe((data:any) => {
            this.click_to_call_loading = false;
            console.log(data);
            if(data.status){
                this.response_call_id = data.call_id;
                $("#click_to_call_progress").modal("show");
            } else {
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    endClicktoCall()
    {
        this.progression_msg = "";
        this.end_to_call_btn_disable = true;
        if(this.response_call_id)
        {
            let lead_id_arr = {'response_call_id': this.response_call_id};
            this.leadapi.endClicktoCall(lead_id_arr).subscribe((data:any) => {
                this.end_to_call_btn_disable = false;
                $('#click_to_call_progress').modal('hide');
            }, error => {
                this.sharedapi.checkError(error);
            });
        } else {
            this.sharedapi.checkError("Please reload the page. Something went to wrong.");
        }
        
    }

    showFeedbackDescriptionModal(leadId,feedback_description) {
        if(this.myrole=='1' || (this.myrole=='4' && this.is_doctor_access!='1')){
            this.feedbackDescriptionForm.patchValue({
                'lead_id':leadId,  
                'feedback_description':feedback_description
            })
            $('#feedbackModelDescription').modal(); 
        }
    }
  
    hideFeedbackDescriptionModal()
    {
        $('#feedbackModelDescription').modal('hide');
    }
  
    async saveFeedbackDescription(){
        this.submitted = true;
        this.feedbackDescLoading = true;
        if (this.feedbackDescriptionForm.invalid) {
            this.feedbackDescLoading = false;
            return;
        }
        await this.leadapi.addFeedbackDescription(this.feedbackDescriptionForm.value)
          .subscribe((data:any) => {
            this.submitted = false;
            this.feedbackDescLoading = false;
            if(data.status){
                this.sharedapi.presentToast(data.msg); 
                this.hideFeedbackDescriptionModal();
                this.loadleads(0,25);
            }
            else{
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.sharedapi.checkError(error);
            }); 
    }
  
}
